// @flow
import { applyMiddleware, createStore, compose, combineReducers } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { user } from '@finect/front-core/User';
import { impersonate } from '@finect/front-core/Impersonate';

const reducer = combineReducers({
  user,
  impersonate
});

/* eslint-disable */
export function configureStore(initialState: Object = {}) {
  return createStore(
    reducer,
    initialState,
    compose(
      applyMiddleware(thunkMiddleware),
      typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (f) => f
    )
  );
}
/* eslint-enable */
